import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { OverlaySsrBoundary } from './OverlaySsrBoundary.js';
import { OverlayPortal } from './OverlayPortal.js';
import { applyCommonProps } from '../utility/commonProps.js';

var _excluded = ["disableScrim", "position", "topOffset", "children"];

// export type OverlayProps = React.ComponentPropsWithoutRef<'div'>;

/**
 * @private
 */
var Overlay = function Overlay(props) {
  var _applyCommonProps = applyCommonProps(props, Overlay),
    _applyCommonProps$dis = _applyCommonProps.disableScrim,
    disableScrim = _applyCommonProps$dis === void 0 ? false : _applyCommonProps$dis,
    _applyCommonProps$pos = _applyCommonProps.position,
    position = _applyCommonProps$pos === void 0 ? 'left' : _applyCommonProps$pos,
    _applyCommonProps$top = _applyCommonProps.topOffset,
    topOffset = _applyCommonProps$top === void 0 ? 0 : _applyCommonProps$top,
    children = _applyCommonProps.children,
    rest = _objectWithoutProperties(_applyCommonProps, _excluded);
  return /*#__PURE__*/React.createElement(OverlaySsrBoundary, null, /*#__PURE__*/React.createElement(OverlayPortal, _extends({}, rest, {
    disableScrim: disableScrim,
    position: position,
    topOffset: topOffset
  }), children));
};

export { Overlay };
